<script>
    export default{
        props: ["attr", "fieldValue"],
        computed: {
          _fieldValue: function() {
            if(this.fieldValue !== undefined && this.fieldValue !== '') {
              return this.fieldValue;
            }
            return {};
          },
          showDashBoard: function() {
            return (this.fieldValue !== undefined && this.fieldValue !== '');
          },
          marginStyle: function() {
            return "padding-top: " + this.attr.marginTop + "px;"
              + "padding-bottom: " + this.attr.marginBottom + "px;"
              + "padding-right: " + this.attr.marginRight + "px;"
              + "padding-left: " + this.attr.marginLeft + "px;";
          }
        },
        mounted () {
          let timer = this.attr.timer;
          let businessRule = this.attr.businessRuleId;

          if (this.attr.businessRuleId) {
            this.$emit('callBusinessRule', businessRule);
            if (timer) {
              setInterval(() => {
                this.$emit('callBusinessRule', businessRule);
              }, (timer + "000"));
            }
          }
        }
    }
</script>

<template>
  <div v-if="showDashBoard" :style="marginStyle">
    <highcharts :options="_fieldValue" :ref="attr.id"></highcharts>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderDashboard.vue?7c461322